
import { Fragment } from 'react';

import useOrgUnitSelection from './UseTeamEntryOrgUnitSelection';

import OmeMeetEntryInfoDropdown from '../../../../components/dropdowns/OmeMeetEntryInfoDropdown';

import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Headings from '@usas/ui-web/components/headings/Headings';
import RadiobuttonList from '@usas/ui-web/components/radiobuttonlists/RadiobuttonList';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const TeamEntryOrgUnitSelection = () => {
    const { state, handleSubmit, formState, errorState, onValueTextPairChanged, onFormValueChanged, onBackClicked,
        personOrgRoleState, omeMeetState, omeMeetEntryInfoState, omeMeetOrgUnitEntryState, omeMeetOrgUnitEntryInfoState } = useOrgUnitSelection();

    return (
        <Fragment>
            <div className={state.showRadioButtonList === true && personOrgRoleState.isArrayLoading !== true ?
                global.DisplayComponent : global.HideComponent} >
                <div className="row">
                    <div className="col-xs-12">
                        <Headings.H3>Enter Meet</Headings.H3>
                    </div>
                </div>
                <div className="row usas-extra-top-margin usas-extra-bottom-margin">
                    <div className="col-xs-12">
                        <Headings.H6>Make a Selection</Headings.H6>
                    </div>
                </div>
                <form onSubmit={handleSubmit} noValidate>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            {omeMeetEntryInfoState.options?.length === 2 ?
                                <ReadOnly
                                    label="OME Meet"
                                    name="omeMeetEntryId"
                                    value={formState.omeMeetEntryName}
                                /> :
                                <OmeMeetEntryInfoDropdown
                                    label="OME Meet*"
                                    name="omeMeetEntryId"
                                    value={formState.omeMeetEntryId}
                                    error={errorState.omeMeetEntryId}
                                    message={errorState.omeMeetEntryId}
                                    onChange={(value, newValueLabel, e) => {
                                        e && e.target && e.target.value &&
                                            onValueTextPairChanged(value, 'omeMeetEntryId', newValueLabel, 'omeMeetEntryName');
                                        onFormValueChanged('orgUnitId', '');
                                    }}
                                    omeMeetId={omeMeetState.objData?.omeMeetId}
                                    isCurrent={true}
                                />}
                        </div>
                        {formState.omeMeetEntryId > 0 &&
                            <Fragment>
                                {state.radioButtonList.length > 0 ?
                                    <div className="col-xs-12 col-sm-6">
                                        <RadiobuttonList
                                            isVertical={true}
                                            items={state.radioButtonList}
                                            label="Team Options*"
                                            name="orgUnitId"
                                            value={formState.orgUnitId}
                                            error={errorState.orgUnitId}
                                            message={errorState.orgUnitId}
                                            onChange={(value) => { onFormValueChanged('orgUnitId', value); }} />
                                    </div> :
                                    <div className="col-xs-12 col-sm-6 col-md-8">
                                        <ReadOnly
                                            label="Team Options*"
                                            name="orgUnitId"
                                            value="The Logged In User is Not Associated with any Organizations that are Invited to the Selected OME Meet and Not Currently Entered. Please Select a Different OME Meet." />
                                    </div>
                                }
                            </Fragment>
                        }
                    </div>
                    <div className="row usas-extra-top-margin usas-extra-bottom-margin">
                        <div className="col-xs-12 usas-extra-top-margin">
                            <PrimaryButton type="submit">Continue</PrimaryButton>&nbsp;
                            <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
                        </div>
                    </div>
                </form>
            </div>
            <PopUpModal
                widthPct={50}
                maxWidth={250}
                title={Constants.SAVING_MSG}
                displayPopUp={omeMeetOrgUnitEntryState.isSaving} />
            <PopUpModal
                widthPct={50}
                maxWidth={250}
                title={Constants.LOADING_MSG}
                displayPopUp={(personOrgRoleState.isArrayLoading || omeMeetState.isArrayLoading || omeMeetOrgUnitEntryInfoState.isObjLoading) && omeMeetOrgUnitEntryState.isSaving === false} />
        </Fragment>
    );
};

export default TeamEntryOrgUnitSelection;